import React from 'react';
import PropTypes from 'prop-types';
import ReactPagination from 'react-js-pagination';
import styles from './styles.scss';


export default class Pagination extends React.Component {
  static get propTypes() {
    return {
      activePage: PropTypes.number,
      itemsCountPerPage: PropTypes.number,
      totalItemsCount: PropTypes.number,
      pageRangeDisplayed: PropTypes.number,
      pageRangeDisplayed: PropTypes.number,
      onChange: PropTypes.func
    }
  }

  static get defaultProps() {
    return {
      activePage: 1,
      itemsCountPerPage: 10,
      totalItemsCount: 1,
      pageRangeDisplayed: 5
    }
  }

  render() {
    const {
      activePage,
      itemsCountPerPage,
      totalItemsCount,
      pageRangeDisplayed,
      onChange
    } = this.props;

    return (
      <ReactPagination
        innerClass={`pagination justify-content-center ${styles.paginationWrapper}`}
        itemClass={`page-item ${styles.paginationItem}`}
        linkClass={`page-link ${styles.link}`}
        activeClass={styles.activeItem}
        activePage={activePage}
        itemsCountPerPage={itemsCountPerPage}
        totalItemsCount={totalItemsCount}
        pageRangeDisplayed={pageRangeDisplayed}
        onChange={onChange}
        prevPageText='◀'
        firstPageText='◀◀'
        nextPageText='▶'
        lastPageText='▶▶'
      />
    );
  }
}



// WEBPACK FOOTER //
// src/components/shared/Pagination/index.jsx